/**
 * Copyright 2024-2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { ResourceExecutionStatus, EventActionType } from "~/generated/graphql";

export const resourceStatusCheckboxes = [
  {
    value: ResourceExecutionStatus.Pending,
    label: "Pending",
  },
  {
    value: ResourceExecutionStatus.InProgress,
    label: "In Progress",
  },
  {
    value: ResourceExecutionStatus.Success,
    label: "Successful",
  },
  {
    value: ResourceExecutionStatus.ManualSuccess,
    label: "Manually Successful",
  },
  {
    value: ResourceExecutionStatus.Failed,
    label: "Failed",
  },
  {
    value: ResourceExecutionStatus.Error,
    label: "Error",
  },
  {
    value: ResourceExecutionStatus.Timeout,
    label: "Timeout",
  },
  {
    value: ResourceExecutionStatus.NotInTimeWindow,
    label: "Not In Time Window",
  },
];

export const actionTypeCheckboxes = [
  {
    value: EventActionType.System,
    label: "System",
  },
  {
    value: EventActionType.Custom,
    label: "Custom",
  },
];
